import {apiConstants} from '../constants/apiurl.constant';
export const miscService = {
    dahsboradCount,
    getTrendingTopics,
    getLatestCourses,
    getNewsList,
    getAllBlogs,
    getFeedbacks
};
function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        // console.log(text);
        if (data.error_code !== 0) {
            if (response.status === 401) {
                // logout();
                // location.reload(true);
            }
            const error = (data && data.message) || response.message;
            return Promise.reject(error);
        }
        return data;
    });
}



//getting dashboard count
async function dahsboradCount(data) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
    const response = await fetch(apiConstants.apiUrl + '/landingdashcounts', requestOptions);
    return handleResponse(response);
}


//getting trending topics
async function getTrendingTopics(data) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
    const response = await fetch(apiConstants.apiUrl + '/trendingtopics', requestOptions);
    return handleResponse(response);
}

//getting trending topics
async function getLatestCourses(data) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
    const response = await fetch(apiConstants.apiUrl + '/latestcourse', requestOptions);
    return handleResponse(response);
}



//getting trending topics
function getNewsList(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + '/landingnewslist', requestOptions).then(handleResponse);
}


//getting trending topics
async function getAllBlogs(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
    const response = await fetch(apiConstants.apiUrl + '/landingbloglist', requestOptions);
    return handleResponse(response);
}
//getting trending topics
async function getFeedbacks(data) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    };
    const response = await fetch(apiConstants.apiUrl + '/landingfeedback', requestOptions);
    return handleResponse(response);
}


